// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__1oKSE","obliqueLineWrap":"membershipbadge_obliqueLineWrap__1pweH","obliqueLine":"membershipbadge_obliqueLine__3P8_e"};